module.exports = __webpack_public_path__ + "img/ria.5890d7ad.jpg";